style= require('./sc-validator.styl')

// Floating always-visible close button — top-right of viewport when open.
// Independent of v2-top layout so it can't be hidden or pushed off-screen.
if this.open
  button.sc-floating-close(
    (click)= this.toggle(),
    title='Close (Esc)',
    style='position:fixed; top:14px; right:14px; z-index:100000; width:48px; height:48px; border-radius:50%; background:#ef4444; color:#fff; border:0; font-size:24px; font-weight:700; cursor:pointer; box-shadow:0 4px 16px rgba(0,0,0,.4); display:flex; align-items:center; justify-content:center;'
  ) ×
.sc-val(class=this.open ? 'open' : 'rail', class='tone-' + this.verdictState.tone)
  if !this.open
    // Thin vertical rail — minimal footprint, click anywhere to expand
    .sc-rail((click)= this.toggle(), title='Open SC Validator')
      .sc-rail-dot(class='tone-' + this.verdictState.tone)
      .sc-rail-title SC VALIDATOR
      if this.totalIssues
        span.sc-rail-badge(class= this.totalIssues > 0 ? 'hot' : '')= this.totalIssues
      .sc-rail-spacer
      .sc-rail-chev ›

  // Legacy V1 compact open-state (kept for reference; never rendered now).
  if false
    .sc-head
      .sc-head-dot(class='tone-' + this.verdictState.tone)
      .sc-eyebrow SC Validator
      .sc-head-sep ·
      .sc-head-sub Post-match · EPL
      .sc-head-spacer
      if this.loading
        .sc-head-spinner ⟳
      button.sc-iconbtn((click)= this.rerun()) ↻
      button.sc-iconbtn.sc-collapse((click)= this.toggle()) ‹
    // Verdict ribbon — collapsed to a single row so stages dominate
    - var v = this.verdictState
    .sc-verdict(class='tone-' + v.tone)
      .sc-verdict-row
        .sc-verdict-ico(class='tone-' + v.tone)
          if v.tone === 'ok'
            svg(viewBox='0 0 16 16', width='14', height='14')
              circle(cx='8', cy='8', r='6.5', fill='none', stroke='currentColor', stroke-width='1.5')
              path(d='M5 8.2 7.3 10.5 11 6.7', stroke='currentColor', stroke-width='1.6', fill='none', stroke-linecap='round', stroke-linejoin='round')
          else if v.tone === 'danger'
            svg(viewBox='0 0 16 16', width='14', height='14')
              circle(cx='8', cy='8', r='6.5', fill='none', stroke='currentColor', stroke-width='1.5')
              path(d='M5.5 5.5l5 5M10.5 5.5l-5 5', stroke='currentColor', stroke-width='1.6', stroke-linecap='round')
          else
            svg(viewBox='0 0 16 16', width='14', height='14')
              path(d='M8 1.5l7 13H1l7-13z', stroke='currentColor', stroke-width='1.5', fill='none')
              rect(x='7.3', y='5.5', width='1.4', height='5', rx='0.5', fill='currentColor')
        .sc-verdict-body
          .sc-verdict-word= v.word
          .sc-verdict-sub= v.sub
      .sc-verdict-foot
        .sc-verdict-match= this.matchLabel || 'No match loaded'
        .sc-verdict-spacer
        if this.hasOutstanding
          span.sc-pill.tone-warn= this.totalIssues + ' open'
        else if this.report
          span.sc-pill.tone-ok all clear

    if this.error
      .sc-state.err Validator unreachable: #{this.error}

    // PIPELINE BAR — 12 beads, status + actor ring, at-a-glance progress
    .sc-pipeline
      .sc-pipeline-meta
        .sc-eyebrow Pipeline · 12 steps
        .sc-pipeline-counts= this.pipelineCounts.done + ' done · ' + this.pipelineCounts.flagged + ' flagged · ' + this.pipelineCounts.pending + ' pending'
      .sc-pipeline-row
        .sc-pipeline-line
        .sc-pipeline-beads
          each b, i in this.pipelineBeads
            if b.actor === 'ai'
              .sc-bead(class='status-' + b.status + ' actor-' + b.actor, title=b.label)
            else
              .sc-bead.clickable(class='status-' + b.status + ' actor-' + b.actor, title=b.label, (click)= this.toggleOp(i))
      .sc-legend
        .sc-legend-item.actor-ai
          .sc-legend-ring
          | AI
        .sc-legend-item.actor-operator
          .sc-legend-ring
          | Operator
        .sc-legend-item.actor-human
          .sc-legend-ring
          | Human

    // STAGE NAVIGATOR
    .sc-stage-nav
      each st in this.stages
        - var counts = this.stageCounts[st.idx] || { total: 0, critical: 0, warn: 0 }
        - var active = this.activeStage === st.idx
        - var stageClass = 'sc-stage-pill stage-' + st.idx
        - if(active) stageClass += ' active'
        - if(counts.critical) stageClass += ' has-critical'
        - else if(counts.warn) stageClass += ' has-warn'
        - else if(counts.total) stageClass += ' has-info'
        button(class=stageClass, (click)= this.setStage(st.idx))
          span.sc-stage-num= st.idx
          span.sc-stage-name= st.short
          if counts.total
            span.sc-stage-badge= counts.total

    // STAGE BODY
    .sc-stage-body
      if this.activeStage === 1
        // ── Stage 1: Lineups validation ────────────────────────
        .sc-stage-head
          .sc-eyebrow Stage 1 · Lineups validation
          .sc-stage-meta Sportyman vs official sources
        if !this.report
          .sc-state Validating lineups…
        else if this.lineupRows.length === 0 && this.suggestionsForStage(1).length === 0
          .sc-empty
            .sc-empty-ico ✓
            .sc-empty-msg Lineups match across sources.
        else
          // Column header
          .sc-l-grid.sc-l-head
            .sc-l-c.l Player
            .sc-l-c PL
            .sc-l-c WS
            .sc-l-c
          each row in this.lineupRows
            .sc-l-grid
              .sc-l-name
                .sc-l-pname= row.player
                .sc-l-pteam= row.team
              .sc-l-c
                span.sc-pip(class='state-' + (row.sources.pl || 'unknown'))= row.sources.pl === 'present' ? '✓' : (row.sources.pl === 'absent' ? '✗' : '?')
              .sc-l-c
                span.sc-pip(class='state-' + (row.sources.ws || 'unknown'))= row.sources.ws === 'present' ? '✓' : (row.sources.ws === 'absent' ? '✗' : '?')
              .sc-l-c
                if row.resolution
                  span.sc-l-flag mismatch
                else
                  span.sc-l-ok aligned
            if row.resolution
              .sc-l-res
                .sc-l-resmsg= row.resolution
                if row.fixHint
                  .sc-l-fix Fix: #{row.fixHint}

      else if this.activeStage === 2
        // ── Stage 2: Timeline review ─────────────────────────
        .sc-stage-head
          .sc-eyebrow Stage 2 · Timeline review
          .sc-stage-meta event-by-event · 3 sources
        if !this.report
          .sc-state Loading timeline…
        else if this.timelineRows.length === 0
          .sc-empty
            .sc-empty-ico ✓
            .sc-empty-msg No events to validate yet.
        else
          .sc-t-table
            .sc-t-head
              .sc-t-min '
              .sc-t-evt Event
              .sc-t-src PL
              .sc-t-src WS
            each row in this.timelineRows
              .sc-t-row
                .sc-t-min= row.smEvent.minute + "'"
                .sc-t-evt
                  span.sc-t-type(class='type-' + row.smEvent.type)= row.smEvent.type.replace('_', ' ')
                  if row.smEvent.player
                    span.sc-t-player= row.smEvent.player
                  if row.smEvent.team
                    span.sc-t-team= row.smEvent.team
                .sc-t-src
                  span.sc-pip(class='state-' + row.match.pl)= row.match.pl === 'match' ? '✓' : row.match.pl === 'missing' ? '✗' : '?'
                .sc-t-src
                  span.sc-pip(class='state-' + row.match.ws)= row.match.ws === 'match' ? '✓' : row.match.ws === 'missing' ? '✗' : '?'
              if row.detail
                .sc-t-detail= row.detail

      else if this.activeStage === 3
        // ── Stage 3: Anomaly detection ───────────────────────
        .sc-stage-head
          .sc-eyebrow Stage 3 · Anomaly detection
          .sc-stage-meta rule engine · 5 categories
        if !this.report
          .sc-state Running rule engine…
        else if this.anomalyRows.length === 0
          .sc-empty
            .sc-empty-ico ✓
            .sc-empty-msg No anomalies detected.
        else
          each a in this.anomalyRows
            .sc-anom(class='sev-' + a.severity)
              .sc-anom-head
                span.sc-anom-rule= a.rule.replace(/_/g, ' ')
                if a.minute
                  span.sc-anom-min= a.minute + "'"
                if a.player
                  span.sc-anom-player= a.player
              .sc-anom-msg= a.message
              if a.fixHint
                .sc-anom-fix
                  span.sc-anom-fixlabel Fix
                  span.sc-anom-fixtext= a.fixHint

      else if this.activeStage === 4
        // ── Stage 4: Finalization ────────────────────────────
        .sc-stage-head
          .sc-eyebrow Stage 4 · Finalization
          .sc-stage-meta capture · save · confirm
        .sc-fin-summary
          .sc-fin-row
            .sc-fin-k Issues open
            .sc-fin-v(class= this.totalIssues > 0 ? 'hot' : 'ok')= this.totalIssues
          .sc-fin-row
            .sc-fin-k Verdict
            .sc-fin-v= this.verdictState.word
          .sc-fin-row
            .sc-fin-k Match
            .sc-fin-v= this.matchLabel
        .sc-fin-actions
          .sc-fin-step
            .sc-fin-step-head
              span.sc-fin-step-num 1
              .sc-fin-step-title Capture evidence
            .sc-fin-step-body
              if this.capture
                .sc-fin-capture-list
                  each e in this.capture.evidence
                    .sc-fin-capture-row(class= e.ok ? 'ok' : 'err')
                      span.sc-pip(class= e.ok ? 'state-present' : 'state-absent')= e.ok ? '✓' : '✗'
                      span.sc-fin-clabel= e.label
                      span.sc-fin-cbytes= e.ok ? Math.round(e.bytes / 1024) + ' KB' : '—'
                .sc-fin-capture-meta Captured #{(this.capture.takenAt || '').slice(0,19)}
              button.sc-cta((click)= this.captureEvidence(), disabled= this.capturing)
                = this.capturing ? 'Capturing…' : (this.capture ? 'Re-capture all sources' : 'Capture all sources')
          .sc-fin-step
            .sc-fin-step-head
              span.sc-fin-step-num 2
              .sc-fin-step-title Save evidence
            .sc-fin-step-body
              button.sc-cta.secondary((click)= this.downloadEvidence(), disabled= !this.capture) Download JSON bundle
              if !this.capture
                .sc-fin-step-hint Capture first to enable download.
          .sc-fin-step
            .sc-fin-step-head
              span.sc-fin-step-num 3
              .sc-fin-step-title Confirm & post
            .sc-fin-step-body
              if this.confirmed
                .sc-fin-confirmed
                  span.sc-pip.state-present ✓
                  | Confirm event fired — click Sportyman's native "Confirm" button to commit.
              else
                button.sc-cta.primary(class= this.hasOutstanding ? 'warn' : '', (click)= this.confirmAndPost(), disabled= !this.report)
                  if this.hasOutstanding
                    | Resolve #{this.totalIssues} issue#{this.totalIssues===1 ? '' : 's'} first ·
                    |  Confirm anyway
                  else
                    | Confirm & post
                .sc-fin-step-hint Read-only validator. Confirm hands off to Sportyman's native confirmation UI.

    .sc-foot AI assists · human confirmation stays mandatory

  if this.open
    // ──────────────────────────────────────────────────────────────────
    //  v2 full-screen layout (mockup: Stats validation tool upd.png)
    //  Mounted alongside the legacy compact view; CSS toggles visibility
    //  via body.sc-val-open. Same data sources (lineupRows / timelineRows
    //  / anomalyRows / suggestions) — just a richer presentation.
    // ──────────────────────────────────────────────────────────────────
    .sc-v2-top
      .sc-v2-logo
        .sc-v2-logo-dot
        | SC Validator
        span.sc-v2-version v2.0
      .sc-v2-match
        .lbl= this.matchLabel || 'No match loaded'
        .sub= 'Completed stages: ' + (this.completedStagesCount || 0) + '/4 · ' + (this.report && this.report.externalSource ? this.report.externalSource : 'source pending')
      .sc-v2-actions
        button.sc-v2-btn(class= this.loading ? 'is-loading' : '', (click)= this.rerun(), disabled= this.loading)
          if this.loading
            span.sc-v2-spin
            | Validating · #{this.formatSec(this.validatingElapsedSec)} / ~#{this.formatSec(this.validatingEtaSec || 90)}
          else
            span ↻
            |  Re-run All
        button.sc-v2-btn((click)= this.share())
          | 🔗
          if this.shareCopied
            |  Copied!
          else
            |  Share
        button.sc-v2-btn((click)= this.captureEvidence(), disabled= this.capturing)
          if this.capturing
            | 📷 Capturing…
          else
            | 📷 Screenshots
          span.sc-v2-version= (this.capture && this.capture.evidence ? this.capture.evidence.length : (this.report && this.report.findings ? this.report.findings.length : 0))

    .sc-v2-grid
      .sc-v2-rail
        each st in this.stages
          - var counts = this.stageCounts[st.idx] || { total: 0, critical: 0, warn: 0 }
          - var active = this.activeStage === st.idx
          - var stageState = 'pending'
          - if (st.idx < this.activeStage) stageState = 'completed'
          - else if (st.idx === this.activeStage) stageState = 'progress'
          - var cardCls = 'sc-v2-stage-card state-' + stageState
          - if (active) cardCls += ' active'
          div(class=cardCls, (click)= this.setStage(st.idx))
            .num= st.idx
            .eyebrow STAGE #{st.idx}
            .name= st.short || ('Stage ' + st.idx)
            .desc= st.long || ''
            .status
              if stageState === 'completed'
                | ✓ Completed
              else if stageState === 'progress'
                | ◐ In Progress
              else
                | ○ Pending

      .sc-v2-main
        // Render ALL 4 stages stacked vertically (mockup-aligned). Rail
        // navigation = scroll-anchor. activeStage still indicates rail focus.
        .sc-v2-panel(id="sc-v2-stage-1")
          .sc-v2-panel-head
            .sc-v2-panel-title STAGE 1 — LINEUPS VALIDATION
            - var passed = (this.suggestionsForStage(1) || []).length === 0
            .sc-v2-panel-badge(class= passed ? 'ok' : 'pending')= passed ? '✓ Stage 1 Passed' : '◐ Review needed'
          - var allRowsK = this.lineupRows || []
          - var sCnt = allRowsK.filter(function(r){return (r.role||'starter')==='starter'}).length
          - var bCnt = allRowsK.filter(function(r){return r.role==='bench'}).length
          - var nCnt = allRowsK.filter(function(r){return r.role==='notInSquad'}).length
          - var mismatch = allRowsK.filter(function(r){return !!r.resolution}).length
          .sc-v2-pills
            .sc-v2-pill-card
              .l Starters
              .row
                .v= sCnt + '/' + sCnt
                if !mismatch
                  span.tag.ok All matched
            .sc-v2-pill-card
              .l Bench
              .row
                .v= bCnt + '/' + bCnt
                if bCnt
                  span.tag.ok All matched
            .sc-v2-pill-card
              .l Mismatches
              .row
                .v(class= mismatch ? 'warn' : '')= mismatch
                if mismatch
                  span.tag.err →
            .sc-v2-pill-card
              .l Unconfirmed
              .row
                .v= nCnt
          - var allRows = this.lineupRows || []
          - var startCount = allRows.filter(function(r){ return (r.role||'starter')==='starter' }).length
          - var benchCount = allRows.filter(function(r){ return r.role==='bench' }).length
          - var notInCount = allRows.filter(function(r){ return r.role==='notInSquad' }).length
          - var userTab = this.lineupTab
          - var tab = userTab || (startCount ? 'starter' : (benchCount ? 'bench' : (notInCount ? 'notInSquad' : 'starter')))
          if startCount > 0 && startCount < 22
            .sc-v2-warning(style='background:#ef4444; color:white; padding:8px 12px; border-radius:6px; margin:8px 0; font-weight:600;')
              | ⚠ Only #{startCount} starters detected — Sportyman expects 22 (11 per team). Check confirmed lineup pages for missing players.
          .sc-v2-tabs
            div(class= 'sc-v2-tab' + (tab==='starter'?' active':'') + (startCount?'':' empty'), (click)= startCount ? this.setLineupTab('starter') : null)= 'Starters (' + startCount + ')'
            div(class= 'sc-v2-tab' + (tab==='bench'?' active':'') + (benchCount?'':' empty'), (click)= benchCount ? this.setLineupTab('bench') : null)= 'Bench (' + benchCount + ')'
            div(class= 'sc-v2-tab' + (tab==='notInSquad'?' active':'') + (notInCount?'':' empty'), (click)= notInCount ? this.setLineupTab('notInSquad') : null)= 'Not in Squad (' + notInCount + ')'
          - var visibleRows = allRows.filter(function(r){ return (r.role||'starter') === tab })
          if visibleRows.length
            table.sc-v2-table
              thead
                tr
                  th #
                  th Player
                  th Sportyman
                  th Fanteam
                  th Premier League
                  th WhoScored
                  th FotMob
                  th SofaScore
                  th Opta
                  th Status
                  th Resolution (What to fix)
                  th Action
              tbody
                each row, i in visibleRows
                  - var src = row.sources || {}
                  - var smPresent = src.sm === 'present'
                  - var plPresent = src.pl === 'present'
                  - var wsPresent = src.ws === 'present'
                  - var fmPresent = src.fm === 'present'
                  - var sofaPresent = src.sofa === 'present'
                  - var fplPresent = src.fpl === 'present'
                  - var optaPresent = src.opta === 'present'
                  - var ftPresent = src.ft === 'present'
                  - var smAbsent = src.sm === 'absent'
                  - var plAbsent = src.pl === 'absent'
                  - var wsAbsent = src.ws === 'absent'
                  - var fmAbsent = src.fm === 'absent'
                  - var sofaAbsent = src.sofa === 'absent'
                  - var fplAbsent = src.fpl === 'absent'
                  - var optaAbsent = src.opta === 'absent'
                  - var ftAbsent = src.ft === 'absent'
                  - var plUnknown = !plPresent && !plAbsent
                  - var wsUnknown = !wsPresent && !wsAbsent
                  tr
                    td= i + 1
                    td= row.player
                    td
                      if smPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if smAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if ftPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if ftAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if plPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if plAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if wsPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if wsAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if fmPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if fmAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if sofaPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if sofaAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if optaPresent
                        span.sc-v2-pip.ok ✓
                        |  Yes
                      else if optaAbsent
                        span.sc-v2-pip.err ✗
                        |  No
                      else
                        span.sc-v2-pip.warn ◐
                        |  N/A
                    td
                      if row.resolution
                        span.sc-v2-status.err ⊘ Mismatch
                      else if plPresent && wsPresent
                        span.sc-v2-status.ok ✓ Match
                      else if plUnknown && wsUnknown
                        span.sc-v2-status.warn ◐ Unconfirmed
                      else
                        span.sc-v2-status.err ⊘ Partial
                    td
                      if row.resolution
                        | #{row.resolution}
                      else
                        | —
                    td
                      if row.resolution
                        button.sc-v2-action-btn Mark Added
                      else
                        | —
          else
            div(style="color:#9fb3c8; padding:18px; font-size:12px")
              if !allRows.length
                | No lineup rows from validator yet.
              else if tab === 'notInSquad'
                span.sc-v2-pip.ok ✓
                |  All #{startCount + benchCount} squad players are accounted for (no omissions).
              else if tab === 'bench' && !benchCount
                span.sc-v2-pip.warn ◐
                |  No bench data for this match.
              else if tab === 'starter' && !startCount
                span.sc-v2-pip.warn ◐
                |  No starters recorded — match may not have begun.
              else
                | No rows in this view.

        .sc-v2-panel(id="sc-v2-stage-2")
          .sc-v2-panel-head
            .sc-v2-panel-title STAGE 2 — TIMELINE REVIEW
            .sc-v2-panel-badge.warn ◐ In Progress
          - var allEvents = this.timelineRows || []
          - var goalCount = allEvents.filter(function(r){ return /goal/i.test(r.smEvent && r.smEvent.type || '') && !/own/i.test(r.smEvent && r.smEvent.type || '') }).length
          - var cardCount = allEvents.filter(function(r){ return /card/i.test(r.smEvent && r.smEvent.type || '') }).length
          - var subCount = allEvents.filter(function(r){ return /sub/i.test(r.smEvent && r.smEvent.type || '') }).length
          - var assistCount = allEvents.filter(function(r){ return /assist/i.test(r.smEvent && r.smEvent.type || '') }).length
          - var otherCount = allEvents.length - goalCount - cardCount - subCount - assistCount
          - var tlTab = this.timelineTab || 'all'
          .sc-v2-tabs
            div(class='sc-v2-tab' + (tlTab==='all'?' active':''), (click)= this.setTimelineTab('all'))= 'All Events (' + allEvents.length + ')'
            div(class='sc-v2-tab' + (tlTab==='goals'?' active':''), (click)= this.setTimelineTab('goals'))= 'Goals (' + goalCount + ')'
            div(class='sc-v2-tab' + (tlTab==='assists'?' active':''), (click)= this.setTimelineTab('assists'))= 'Assists (' + assistCount + ')'
            div(class='sc-v2-tab' + (tlTab==='cards'?' active':''), (click)= this.setTimelineTab('cards'))= 'Cards (' + cardCount + ')'
            div(class='sc-v2-tab' + (tlTab==='subs'?' active':''), (click)= this.setTimelineTab('subs'))= 'Subs (' + subCount + ')'
            div(class='sc-v2-tab' + (tlTab==='other'?' active':''), (click)= this.setTimelineTab('other'))= 'Other (' + otherCount + ')'
          - var filteredEvents = allEvents.filter(function(r){
          -   var t = (r.smEvent && r.smEvent.type) || ''
          -   if (tlTab === 'all') return true
          -   if (tlTab === 'goals') return /goal/i.test(t) && !/own/i.test(t)
          -   if (tlTab === 'assists') return /assist/i.test(t)
          -   if (tlTab === 'cards') return /card/i.test(t)
          -   if (tlTab === 'subs') return /sub/i.test(t)
          -   return !/goal|card|sub|assist/i.test(t)
          - })
          if filteredEvents.length
            table.sc-v2-table
              thead
                tr
                  th Time
                  th Event
                  th Player
                  th Sportyman
                  th Fanteam
                  th Premier League
                  th WhoScored
                  th FotMob
                  th SofaScore
                  th Opta
                  th Status
                  th Resolution
              tbody
                each row in filteredEvents
                  - var t = (row.smEvent.type || '').toLowerCase()
                  - var icon = '·'
                  - var iconCls = 'evt-default'
                  - var label = (row.smEvent.type || 'event').replace(/_/g,' ')
                  - if (/goal|score/.test(t) && !/own/.test(t)) { icon = '⚽'; iconCls = 'evt-goal'; label = 'Goal' }
                  - if (/own.?goal/.test(t)) { icon = '⚽'; iconCls = 'evt-owngoal'; label = 'Own goal' }
                  - if (/yellow.?card|yc/.test(t)) { icon = '▮'; iconCls = 'evt-yellow'; label = 'Yellow Card' }
                  - if (/red.?card|rc/.test(t)) { icon = '▮'; iconCls = 'evt-red'; label = 'Red Card' }
                  - if (/sub|change/.test(t)) { icon = '⇄'; iconCls = 'evt-sub'; label = 'Substitution' }
                  - if (/penalty/.test(t)) { icon = 'P'; iconCls = 'evt-penalty'; label = 'Penalty' }
                  - if (/blunder/.test(t)) { icon = '!'; iconCls = 'evt-blunder'; label = 'Blunder' }
                  - if (/save/.test(t)) { icon = '🧤'; iconCls = 'evt-save'; label = 'Save' }
                  - if (/foul/.test(t)) { icon = '⚠'; iconCls = 'evt-foul'; label = 'Foul' }
                  - var pName = (row.smEvent.player || '').toLowerCase()
                  - var lineupSrc = {}
                  - if (this.lineupRows) { for (var __i = 0; __i < this.lineupRows.length; __i++) { if ((this.lineupRows[__i].player || '').toLowerCase() === pName) { lineupSrc = this.lineupRows[__i].sources || {}; break } } }
                  - var minute = row.smEvent.minute || 0
                  - var isLate = minute >= 90
                  - var teamName = (row.smEvent.team || '').toLowerCase()
                  - var homeTeamName = (this.report && this.report.provenance && this.report.provenance.sportyman && this.report.provenance.sportyman.homeTeam || '').toLowerCase()
                  - var teamCls = teamName ? (teamName === homeTeamName ? 'team-home' : 'team-away') : 'team-unknown'
                  - var rowCls = teamCls + (isLate ? ' event-late' : '')
                  tr(class=rowCls)
                    td(style=isLate ? 'color:#ff5b5b; font-weight:700;' : '')= row.smEvent.minute + "'"
                    td
                      span.sc-v2-eico(class=iconCls)= icon
                      | #{label}
                    td= row.smEvent.player || '—'
                    - var pipClass = function(v) { return v === 'match' ? 'ok' : (v === 'minor' ? 'warn' : (v === 'mismatch' || v === 'missing' ? 'err' : 'warn')) }
                    - var pipIcon = function(v) { return v === 'match' ? '✓' : (v === 'minor' ? '◐' : (v === 'mismatch' || v === 'missing' ? '✗' : '◐')) }
                    - var pipLabel = function(v) { return v === 'unknown' ? 'N/A' : (row.smEvent.minute + "'") }
                    td
                      span.sc-v2-pip.ok ✓
                      |  #{row.smEvent.minute}'
                    - var ftV = (row.match && row.match.ft) || 'unknown'
                    td
                      span.sc-v2-pip(class= pipClass(ftV))= pipIcon(ftV)
                      |  #{pipLabel(ftV)}
                    - var plV = (row.match && row.match.pl) || 'unknown'
                    - var wsV = (row.match && row.match.ws) || 'unknown'
                    td
                      span.sc-v2-pip(class= pipClass(plV))= pipIcon(plV)
                      |  #{pipLabel(plV)}
                    td
                      span.sc-v2-pip(class= pipClass(wsV))= pipIcon(wsV)
                      |  #{pipLabel(wsV)}
                    - var fmV = (row.match && row.match.fm) || 'unknown'
                    - var sofaV = (row.match && row.match.sofa) || 'unknown'
                    td
                      span.sc-v2-pip(class= pipClass(fmV))= pipIcon(fmV)
                      |  #{pipLabel(fmV)}
                    td
                      span.sc-v2-pip(class= pipClass(sofaV))= pipIcon(sofaV)
                      |  #{pipLabel(sofaV)}
                    - var optaV = (row.match && row.match.opta) || 'unknown'
                    td
                      span.sc-v2-pip(class= pipClass(optaV))= pipIcon(optaV)
                      |  #{pipLabel(optaV)}
                    - var mm = [plV, wsV, fmV, sofaV, optaV].filter(function(v){ return v === 'mismatch' }).length
                    td
                      if mm >= 3
                        span.sc-v2-status.err ⊘ Mismatch
                      else if mm > 0
                        span.sc-v2-status.warn ◐ Minor Diff
                      else
                        span.sc-v2-status.ok ✓ Match
                    td= row.detail || '—'
          else
            - var tlLabel = tlTab === 'all' ? 'events' : (tlTab === 'goals' ? 'goals' : (tlTab === 'cards' ? 'cards' : (tlTab === 'subs' ? 'substitutions' : 'other events')))
            div(style="color:#9fb3c8; padding:18px; font-size:12px")
              if allEvents.length
                | No #{tlLabel} for this match.
              else
                | No timeline rows from validator yet.

        .sc-v2-panel(id="sc-v2-stage-3")
          .sc-v2-panel-head
            .sc-v2-panel-title STAGE 3 — ANOMALY DETECTION
            - var rows = this.anomalyRows || []
            - var flagged = rows.filter(function(a){ return a.severity==='warn' || a.severity==='error' }).length
            - var total = rows.length || 5
            - var passed = total - flagged
            .sc-v2-panel-badge(class= flagged ? 'pending' : 'ok')= 'Checks: ' + passed + '/' + total
          .sc-v2-checks
            - var liveChecks = (this.anomalyRows && this.anomalyRows.length) ? this.anomalyRows.map(function(a){ return {n:a.rule, d:a.message, sev:a.severity||'info'} }) : [{n:'Yellow Cards Timing',d:'No event data yet — load match.',sev:'info'},{n:'Substitutions Timing',d:'No event data yet — load match.',sev:'info'},{n:'Clean Sheet Points',d:'No event data yet — load match.',sev:'info'},{n:'Penalties',d:'No event data yet — load match.',sev:'info'},{n:'Fantasy Assists',d:'No event data yet — load match.',sev:'info'}]
            each c in liveChecks
              .sc-v2-check-card
                h4= c.n
                span.tag(class= c.sev==='warn' ? 'warn' : (c.sev==='error' ? 'err' : 'ok'))= c.sev==='warn' ? '◐ Review' : (c.sev==='error' ? '✗ Flag' : '✓ Checked')
                p= c.d

        .sc-v2-panel(id="sc-v2-stage-4-keystats")
          .sc-v2-panel-head
            .sc-v2-panel-title STAGE 4 — KEY STATS (Shots, Saves, Penalties)
            - var ksRows = this.keyStatsRows || []
            .sc-v2-panel-badge(class= ksRows.length ? 'ok' : 'pending')= ksRows.length ? (ksRows.length + ' players with key stats') : '◐ Awaiting data'
          if ksRows.length
            table.sc-v2-table
              thead
                tr
                  th Player
                  th Team
                  th Shots
                  th SoT
                  th GK Saves
                  th Pen Won
                  th Pen Caused
                  th Status
              tbody
                each row in ksRows
                  tr
                    td= row.player
                    td(style='font-size:11px;opacity:0.7;')= row.team || '—'
                    td(style= row.shots > 0 ? 'font-weight:600;color:#4f8cff;' : 'opacity:0.4;')= row.shots || '—'
                    td(style= row.sot > 0 ? 'font-weight:600;color:#10b981;' : 'opacity:0.4;')= row.sot || '—'
                    td(style= row.saves > 0 ? 'font-weight:600;color:#f59e0b;' : 'opacity:0.4;')= row.saves || '—'
                    td(style= row.penWon > 0 ? 'font-weight:600;color:#10b981;' : 'opacity:0.4;')= row.penWon || '—'
                    td(style= row.penCaused > 0 ? 'font-weight:600;color:#ef4444;' : 'opacity:0.4;')= row.penCaused || '—'
                    td
                      if row.flag
                        span.sc-v2-status.err ⊘ #{row.flag}
                      else
                        span.sc-v2-status.ok ✓ OK
          else
            div(style='padding:18px; color:#9fb3c8; font-size:12px;') Key stats are derived from match events + Opta stats grid. Re-run validator to populate.

        .sc-v2-panel(id="sc-v2-stage-4")
          .sc-v2-panel-head
            .sc-v2-panel-title STAGE 5 — FINALIZATION
            .sc-v2-panel-badge(class= this.confirmed ? 'ok' : 'warn')= this.confirmed ? '✓ Posted' : 'Ready to Complete'
          - var plId = (this.report && this.report.provenance && this.report.provenance.external && this.report.provenance.external.eventId) || null
          - var prov = this.report && this.report.provenance && this.report.provenance.sportyman || {}
          - var externalUnavailable = this.report && (this.report.externalSource === 'unavailable' || this.report.external_unavailable === true)
          - var homeName = prov.homeTeam || (this.report && this.report.matchLabel ? (this.report.matchLabel.split(/\s+\d/)[0] || '').trim() : '')
          - var awayName = prov.awayTeam || (this.report && this.report.matchLabel ? ((this.report.matchLabel.match(/\d\s+(.+?)(\s+·|$)/) || [])[1] || '').trim() : '')
          - var startTime = prov.startTime
          - var matchDate = startTime ? new Date(startTime).toISOString().slice(0,10) : null
          - var base = this.validatorBase || ((typeof window !== 'undefined' && window.__SC_VALIDATOR_BASE__) || '')
          - var shots = []
          - if (plId) { shots.push({label:'PL · Summary', view:'summary', src:'pl'}, {label:'PL · Lineups', view:'lineups', src:'pl'}, {label:'PL · Events', view:'timeline', src:'pl'}, {label:'PL · Stats', view:'stats', src:'pl'}) }
          - if (homeName && awayName && matchDate && !externalUnavailable) { shots.push({label:'FotMob · Summary', view:'summary', src:'fm'}, {label:'FotMob · Lineups', view:'lineups', src:'fm'}, {label:'FotMob · Events', view:'timeline', src:'fm'}, {label:'FotMob · Stats', view:'stats', src:'fm'}) }
          - if (homeName && awayName && matchDate && !externalUnavailable) { shots.push({label:'WhoScored · Summary', view:'summary', src:'ws'}, {label:'WhoScored · Live (events)', view:'live', src:'ws'}, {label:'WhoScored · Lineups', view:'lineups', src:'ws'}, {label:'WhoScored · Stats', view:'stats', src:'ws'}) }
          - if (homeName && awayName && !externalUnavailable) { shots.push({label:'SofaScore · Summary', view:'summary', src:'sofa'}, {label:'SofaScore · Lineups', view:'lineups', src:'sofa'}, {label:'SofaScore · Events', view:'events', src:'sofa'}, {label:'SofaScore · Stats', view:'stats', src:'sofa'}) }
          - if (homeName && awayName && matchDate && !externalUnavailable) { shots.push({label:'Opta · Match detail', view:'match', src:'opta'}) }
          - if (!externalUnavailable) { shots.push({label:'FPL · Fixtures', src:'fpl', generic:true}) }
          - var srcLabel = externalUnavailable ? '· external sources unavailable for this match (synthetic / non-EPL data)' : '· sources: premierleague.com + fotmob.com + sofascore.com + whoscored.com + fantasy.premierleague.com + optaplayerstats.statsperform.com'
          - var genAt = this.report && this.report.provenance && this.report.provenance.generatedAt
          - var capTs = genAt ? new Date(genAt).toLocaleString('sv-SE', {hour:'2-digit',minute:'2-digit',second:'2-digit',day:'2-digit',month:'2-digit'}) : null
          - var ranBy = this.report && this.report.provenance && this.report.provenance.audit && this.report.provenance.audit.ranBy
          .sc-v2-evidence-head Evidence & Screenshots (#{shots.length}) #{srcLabel}
          if capTs || ranBy
            .sc-v2-evidence-audit(style='font-size:11px;opacity:0.7;margin-top:4px;')
              if capTs
                span Captured #{capTs}
              if ranBy
                |  · by #{ranBy}
          - var srcDomain = { pl:'premierleague.com', fm:'fotmob.com', sofa:'sofascore.com', ws:'whoscored.com', fpl:'fantasy.premierleague.com', opta:'optaplayerstats.statsperform.com' }
          - var cacheBust = genAt ? '?t=' + encodeURIComponent(genAt) : '?t=' + Date.now()
          - var zipUrl = (homeName && awayName && matchDate) ? (base + '/shots-zip?home=' + encodeURIComponent(homeName) + '&away=' + encodeURIComponent(awayName) + '&date=' + matchDate + (plId ? '&plId=' + plId : '')) : null
          if zipUrl
            a.sc-v2-zip-btn(href= zipUrl, download=true, style='display:inline-block; margin:8px 0; padding:6px 12px; background:rgba(79,140,255,0.15); border:1px solid rgba(79,140,255,0.4); border-radius:6px; color:#4f8cff; font-size:12px; text-decoration:none;')
              | 📦 Download all evidence (.zip)
          .sc-v2-evidence-grid
            each s, i in shots
              - var shotUrl
              - if (s.generic) { shotUrl = base + '/shot-src/' + s.src + cacheBust }
              - else if (s.src === 'pl') { shotUrl = base + '/shot/' + plId + '/' + s.view + cacheBust }
              - else if (s.src === 'fm') { shotUrl = base + '/shot-fm/' + encodeURIComponent(homeName) + '/' + encodeURIComponent(awayName) + '/' + matchDate + '/' + s.view + cacheBust }
              - else if (s.src === 'ws' || s.src === 'sofa' || s.src === 'opta') { shotUrl = base + '/shot-' + s.src + '/' + encodeURIComponent(homeName) + '/' + encodeURIComponent(awayName) + '/' + matchDate + '/' + s.view + cacheBust }
              - else { shotUrl = base + '/shot-src/' + s.src + cacheBust }
              .sc-v2-shot.clickable(class= 'src-'+s.src, (click)= this.openLightboxAt(i))
                img.sc-v2-shot-thumb(src= shotUrl, alt=s.label, loading='lazy')
                .sc-v2-shot-name= s.label
                .sc-v2-shot-time= srcDomain[s.src] || s.src
            .sc-v2-shot.sc-v2-shot-add((click)= this.captureEvidence())
              .sc-v2-shot-thumb.add
                span 📷
              .sc-v2-shot-name Add
              .sc-v2-shot-time Screenshot
          .sc-v2-finrow
            .sc-v2-notes-col
              .sc-v2-block-label
                | Notes
                span.sc-v2-block-opt (optional)
              textarea.sc-v2-notes(placeholder='All stages passed. No issues found. Ready to post.', value= this.notes || '', (input)= this.setNotes(e.target.value))
            .sc-v2-actions-col
              .sc-v2-block-label Final Actions
              .sc-v2-fa-row
                span.sc-v2-pip.ok ✓
                | All stages passed
              .sc-v2-fa-row
                span.sc-v2-pip.ok ✓
                | Evidence collected
              .sc-v2-fa-row
                span.sc-v2-pip.ok ✓
                | Anomalies cleared
              button.sc-v2-confirm-btn((click)= this.confirmAndPost(), disabled= this.confirmed)
                if this.confirmed
                  | ✓ Posted (locked)
                else
                  | Confirm & Post
                  span(style="margin-left:6px") ✈
              if this.confirmed && homeName && awayName
                .sc-v2-slack-confirm(style='margin-top:8px; padding:10px; background:rgba(79,140,255,0.08); border:1px solid rgba(79,140,255,0.3); border-radius:6px; font-family:monospace; font-size:11px; cursor:pointer;', (click)= this.copySlackConfirm(), title='Click to copy to clipboard')
                  | 📋 #{homeName} - #{awayName} match is AI checked & confirmed
                  br
                  span(style='font-size:10px; opacity:0.6;') Click to copy for Slack
            .sc-v2-success-col
              if this.confirmed
                .sc-v2-success-card
                  .sc-v2-success-icon ✓
                  .sc-v2-success-body
                    .sc-v2-block-label Success
                    .sc-v2-success-msg Match confirmed and posted
                    .sc-v2-success-time= (this.confirmedAt || new Date().toLocaleString('sv-SE'))
                    a.sc-v2-success-link(href='#', (click)= this.toggle()) View Posted Match ↗
              else
                .sc-v2-success-card.pending
                  .sc-v2-success-icon ○
                  .sc-v2-success-body
                    .sc-v2-block-label Status
                    .sc-v2-success-msg Awaiting confirmation
                    .sc-v2-success-time Click "Confirm & Post" to finalize

    - var lbList = this.lightboxList || []
    - var lbIdx = this.lightboxIndex
    if lbList.length && lbIdx != null && lbIdx >= 0
      - var cur = lbList[lbIdx] || {}
      .sc-v2-lightbox((click)= this.closeLightbox())
        button.sc-v2-lb-nav.prev((click)= this.lightboxPrev(e), disabled= lbIdx === 0) ‹
        .sc-v2-lightbox-inner((click)= this.stopProp(e))
          .sc-v2-lightbox-bar
            .sc-v2-lightbox-title= (cur.label || 'Screenshot') + ' · ' + (lbIdx+1) + '/' + lbList.length
            button.sc-v2-lightbox-close((click)= this.closeLightbox()) ✕
          img.sc-v2-lightbox-img(src= cur.url, alt= cur.label || '')
        button.sc-v2-lb-nav.next((click)= this.lightboxNext(e), disabled= lbIdx >= lbList.length-1) ›

    .sc-v2-bot
      .l
        | Validator:
        b= this.userName || 'Kevin'
        span.online ● Online
      .m Match ID: #{this.matchId || '—'} · Source: Sportyman · Fanteam · Opta · WhoScored
      .r
        | Auto-save: On
        span.sc-v2-pip.ok ✓
